import React from "react";
import { BodyCard, HeadCard, BottomCard } from "./styles";
import { RootState } from "../../redux/reducers/index";
import { Close } from "../MainModal/Close";
import { Card } from "../../theme/theme";
import ModalButton from "../ModalButton";
import { StyledPopup } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { handleToggleCityChanged } from "../../redux/actions";
import { language } from "../../utils/language";

const CityChangedSuccessfully = (props: any) => {
	const { color } = props;
	const dispatch = useDispatch();

	const elogisticaState: any = useSelector(
		(state: RootState) => state.elogistica
	);

	const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);

	return (
		<>
			<StyledPopup
				open={elogisticaState.showCityChangedModal}
				on={[]}
				trigger={<div>{props.children}</div>}
				position="bottom center"
				className="containerPopup"
			>
				{(close: any) => (
					<Card>
						<HeadCard>
							<div>{language[homeState.default_language]["localization"]}</div>
							<Close
								onClick={() => {
									dispatch(handleToggleCityChanged());
								}}
								color={color}
							>
								{" "}
							</Close>
						</HeadCard>
						<BodyCard>{language[homeState.default_language]["localizationChangeSuccess"]}</BodyCard>
						<BottomCard>
							<ModalButton
								color={color}
								secondary={false}
								onClick={() => {
									dispatch(handleToggleCityChanged());
								}}
							>
								{language[homeState.default_language]["ok"]}
							</ModalButton>
						</BottomCard>
					</Card>
				)}
			</StyledPopup>
		</>
	);
};

export default CityChangedSuccessfully;
